import { createFileRoute } from '@tanstack/react-router'
import { CustomerConsolidatedReportPage } from '@/features/customer/pages/consolidated-report'

export const Route = createFileRoute('/_authenticated/customer/consolidated-report')({
  component: CustomerConsolidatedReportPage,
})

